import React, { useState, useEffect } from "react";
import Card from "../Card/Card.jsx";
import { formatDateTime } from "../../../helpers/helpers.jsx";
import { concerts_sidebar_title, concerts_sidebar_empty } from "./sidebar.json";

import "./sidebar.css";

const SidebarConcerts = ({ lang }) => {
  const [concerts, setConcerts] = useState([]);
  let show_concerts;

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    fetch("https://sancta-cecilia.cz/concerts_json.php?year=0")
      .then((res) => res.json())
      .then((data) => {
        data.sort((a, b) => a.datum.localeCompare(b.datum));
        setConcerts(data);
      });
  }, []);

  if (concerts.length > 0) {
    show_concerts = concerts
      .filter((concert) => concert.canceled === "0")
      .map((concert, index) => (
        <div key={index} className="sidebarConcertContainer">
          <div className="sidebarConcertDate">
            {formatDateTime(lang, concert.datum + "T" + concert.cas, true)}
          </div>
          <div className="sidebarConcertText">
            {concert["misto_" + lang.substring(0, 2)] === ""
              ? concert["misto_cs"]
              : concert["misto_" + lang.substring(0, 2)]}
          </div>
        </div>
      ));
  } else {
    show_concerts = <div className="sidebarConcertEmpty">{concerts_sidebar_empty[lang]}</div>;
  }

  return (
    <Card styleProps="sidebarCard">
      <div className="sidebarHeader">
        <span>{concerts_sidebar_title[lang]} </span>
      </div>
      <div className="sidebarText">{show_concerts}</div>
    </Card>
  );
};

export default SidebarConcerts;



// WEBPACK FOOTER //
// ./src/components/UI/Sidebar/SidebarConcerts.jsx